export const useLinkUrl = (linkUrl) => {
    const isHttpUrl = () => {
        return linkUrl.startsWith("http://");
    };
    const isHttpsUrl = () => {
        return linkUrl.startsWith("https://");
    };
    const fullLinkUrl = () => {
        if (isHttpUrl() || isHttpsUrl()) {
            return linkUrl;
        }
        return `https://${linkUrl}`;
    };
    const nonHttpUrl = () => {
        if (isHttpsUrl()) {
            return linkUrl.split("https://")[1];
        }
        else if (isHttpUrl()) {
            return linkUrl.split("http://")[1];
        }
        else {
            return linkUrl;
        }
    };
    const truncatedUrl = () => {
        const url = nonHttpUrl();
        if (url.length <= 45) {
            return url;
        }
        else {
            return url.slice(0, 45) + "...";
        }
    };
    return {
        httpsUrl: fullLinkUrl(),
        nonHttpUrl: nonHttpUrl(),
        truncatedUrl: truncatedUrl(),
    };
};
//# sourceMappingURL=useLinkUrl.js.map